import { targetAudiences } from '@/mocks/solutionsData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function TargetAudience() {
  return (
    <section className="relative bg-brand-gray py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]">
        <img
          src={readdy('target-aud-bg-v2')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <ScrollReveal variant="fade-up">
            <div className="text-center mb-14">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">适用人群</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight">
                无论处于什么阶段，都有适合您的方案
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {targetAudiences.map((audience, i) => (
              <ScrollReveal key={audience.title} variant="fade-up" delay={i * 100}>
                <div className="bg-white rounded-2xl p-6 md:p-8 border border-brand-light/30 hover:border-brand-cream hover:shadow-md transition-all duration-300 cursor-pointer group">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-brand-light mb-4 group-hover:bg-brand-cream transition-colors">
                    <i className={`${audience.icon} text-brand-deep text-lg`} />
                  </div>
                  <h3 className="text-sm font-semibold text-brand-deep mb-2">{audience.title}</h3>
                  <p className="text-gray-400 text-xs leading-relaxed">{audience.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}